import styled from "styled-components";

export const MobileControllerWrapper = styled.div`
  background: #0e0d2b;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding: 58px 16px 96px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  overflow-y: auto;
`;

export const MobileControllerBottomWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 34px;
  background: #0e0d2b;

  > .item {
    width: 101px;
    height: 42px;
    opacity: 1;
    border-radius: 20px;
    color: #969696;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 11px;
    line-height: 42px;
    text-align: center;
  }

  > .selected {
    background: #6436e7;
    color: #fff;
  }
`;

export const MobileControllerHeader = styled.div`
  display: flex;
  gap: 3px;
  justify-content: space-between;
  align-items: center;

  > .box {
    display: flex;
    flex-direction: column;
    color: #fff;
    gap: 3px;
    > .title {
      font-family: Pretendard;
      font-weight: 700;
      font-size: 18px;
    }

    > .id {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 16px;
    }
  }
`;
